// extracted by mini-css-extract-plugin
export var banner = "_mc-0";
export var settingRow = "_mc-2";
export var titleIcon = "_mc-1";